module.exports = __webpack_public_path__ + "media/images/map-image-1148f93dd6f327d844268086995f9c5f.png";